module.exports = __webpack_public_path__ + "static/media/figma.415c013e.svg";